import '../styles/main.scss';
import '../images/share.jpg';
import Analytics from './analytics';
import WindowEvents from './windowEvents';
import Preloader from './components/ge-preloader';
import Table from './partials/sections/medals-table';

const isProduction = location.hostname !== 'localhost' || location.hostname !== '127.0.0.1';

(($) => {
  $(document).ready(() => {
    // TODO Google Analytics, ativar apenas quando a página for para produção
    if (isProduction) Analytics.init();
    WindowEvents.init();
    Table.init();
    Preloader.hide();
  });
})(jQuery);


/* istanbul ignore if */
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// local_static/templates/quadro_de_medalhas/2018/assets/scripts/main.js